var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C1.89543 1 1 1.89543 1 3V5C1 6.10457 1.89543 7 3 7H13C14.1046 7 15 6.10457 15 5V3C15 1.89543 14.1046 1 13 1H3ZM3 3H13V5H3V3ZM3 9C1.89543 9 1 9.89543 1 11V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V11C15 9.89543 14.1046 9 13 9H3ZM3 11H13V13H3V11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleCard);
export default __webpack_public_path__ + "static/media/Toggle-Card.1b26d39da57a97da5bf3e5028a428172.svg";
export { ForwardRef as ReactComponent };